<script lang="ts">
    import { RewardsAvailableRewardsListWidgetDefinition } from "@apps/rewards/definitions";
    import type { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";

    import Widget from "@components/Widget.svelte";
    import type { LoggerInterface } from "@interfaces/LoggerInterface";

    import type { SelectedDiscountValue } from "./types";

    //Props
    export let locale: string;
    export let dynamicImportManager: DynamicImportManager;
    export let logger: LoggerInterface;
    export let onChange: (value: SelectedDiscountValue) => void;
</script>

{#await dynamicImportManager.importDefault(RewardsAvailableRewardsListWidgetDefinition, true) then RewardsAvailableRewardsListWidget}
    <Widget
        widget={RewardsAvailableRewardsListWidget}
        params={[{ onChange, locale }, logger]}
    />
{:catch error}
    {console.error(
        "Failed to load RewardsAvailableRewardsListWidget module",
        error
    )}
{/await}
